/*

Data preprocessor

*/

(function() {

    var globals = require("./globals.js");
    var utils = require("./utils.js");
    var graph = require("./graph.js");
    
    module.exports = {
	prep: prep,
    }

    var allEvents = [];
    var locations = [];
    var venues = [];
    var eventTypes = [];
    var professions = [];
    var relationships = [];
    var parties = []
    var birthplaces = [];
    var peopleList = [];
    var eventList = [];
    
    function prep(_data) {

	// set language and translate header and copy
	
	setLang()

	for(d in _data.copy) {
	    _data.copy[d] = _data.copy[d][globals.lang];
	};
	
	globals.copy = _data.copy;

	$(".header-brand-link").text("~  "+_data.copy.siteTitle+"  ~");
	$(".about-button").text(_data.copy.aboutTitle);

        _data.events.forEach(function(d) {
	    d.eventName = globals.lang == 'en'? d.eventName : d.eventNameEs;
	    d.eventType = globals.lang == 'en'? d.eventType : _data.copy[d.eventType.toLowerCase()];
	    if(d.venue === 'Unknown' && globals.lang === 'es') {
	    	d.venue = _data.copy[d.venue.toLowerCase()];
		}
//	    d.venue = globals.lang === 'en' && d.venue === 'Unknown' ? d.venue : _data.copy[d.venue.toLowerCase()];
	    eventList.push(d.eventName);
	    updateEventLists(d.location, d.venue, d.eventType);
	    d.type = 'event';

	    //add source media data

	    if(d.relMedia != 'event') {
		linked = [];
		list = d.relMedia.split(',');
		list.forEach(function(l) {
		    linked.push(_data.sources.filter(function(s) { return s.id == l.trim(); })[0]);
		});
		d.relMedia = linked;
	    } else {
		d.relMedia = '';
	    }
	    
	    //set x and y vals
	    if(d.startDate !='') {
		d.ongoing = true;
		d.x = setX(d.startDate, d.endDate);
	    } else {
		d.ongoing = false;
		d.x =  graph.dateToX(d.date);
	    }
	    d.fx = d.x;
	    d.y = setY(d.datasets)
	    
	    //Add y offset for ongoing events
	    if(d.startDate != '') {
		d.y = d.y + ((graph.dateToX(d.endDate) - graph.dateToX(d.startDate)) / 15);
	    }
	});

	assignColorVals(eventTypes);
	
	_data.people.forEach(function(d) {
	    d.type = 'person';
	    d.bioEn = globals.lang == 'en' ? d.bioEn : d.bioEs;
	    d.proffesion = globals.lang == 'en' ? d.proffesion : d.proffesionEs;
	    peopleList.push(d.name)
	    updatePeopleLists(d.proffesion, d.relProtagonist, d.party, d.residence)
	    rel = d.relProtagonist.toLowerCase().split(' ');
	    rel = rel > 1 ? rel[0] + rel[1] : rel[0];
	    relSplit = rel.split(",")
		if(relSplit.length > 1) {
	    	newRel = ''
	    	relSplit.forEach(function(d, i) {
	    		if(i<relSplit.length -1) {
                    newRel += _data.copy[d] + " " + _data.copy['and'] + " "
                } else {
	    			newRel += _data.copy[d]
				}
			})
			d.relProtagonist = newRel;
		} else {
            d.relProtagonist = globals.lang == 'en' ? d.relProtagonist : _data.copy[rel];
        }
        d.relProtagonist = d.relProtagonist === 'Undecided' ? '' : d.relProtagonist;
        d.relProtagonist = d.relProtagonist === 'No decidido' ? '' : d.relProtagonist;

        if(d.relMedia != '') {
		linked = [];
		list = d.relMedia.split(',');
		list.forEach(function(l) {
		    linked.push(_data.sources.filter(function(s) { return s.id == l.trim(); })[0]);
		});
		d.relMedia = linked;
	    } else {
		d.relMedia = '';
	    }
	})

	_data.links.forEach(function(d) {
	    d.relEn = globals.lang == 'en' ? d.relEn : d.relEs;
	});

	_data.sources.forEach(function(d) {
		d.mediaType = globals.lang === 'en' ? d.mediaType : globals.copy[d.mediaType.toLowerCase()]
	})

	_data.peopleList = utils.alphabetise(peopleList);
	_data.eventList = utils.alphabetise(eventList);
	_data.professions = utils.alphabetise(professions);
	_data.relationships = utils.alphabetise(relationships);
	_data.parties = utils.alphabetise(parties);
	_data.birthplaces = utils.alphabetise(birthplaces);
	_data.locations = utils.alphabetise(locations);
	_data.venues = utils.alphabetise(venues);
	_data.eventTypes = eventTypes;
	_data.allDates = assignDates();

	
	return _data;
    }
    
    function updatePeopleLists(prof, rel, party, birth) {
    	if(utils.checkExists(prof, professions, 'none') == false) {
	    professions.push(prof);
	}
	if(utils.checkExists(rel, relationships, 'none') == false) {
	    relationships.push(rel)
	}
	if(utils.checkExists(party, parties, 'none') == false) {
	    parties.push(party)
	}
	if(utils.checkExists(birth, birthplaces, 'none') == false) {
	    birthplaces.push(birth)
	}
    };
    
    function updateEventLists(location, venue, type) {

	if(utils.checkExists(location, locations, 'none') == false) {
	    locations.push(location)
	}
	
	if(utils.checkExists(venue, venues, 'none') == false) {
	    venues.push(venue)
	}

	if(utils.checkExists(type, eventTypes, 'title') == false) {
	    eventTypes.push({color:0, title: type, active: false});
	}
    }

    function setY(datasets) {
	if(datasets.length > 1) {
	    total = 0;
	    for(data in datasets) {
		total = total + globals.yAxis[datasets[data]].yVal;
	    }
	    return total / datasets.length;
	} else {
	    return globals.yAxis[datasets[0]].yVal;
	}
    }

    function setX(start, end) {
	base = graph.dateToX(start);
	halfLen = (graph.dateToX(end) - graph.dateToX(start)) / 2
	return (base + halfLen);
    }

    function assignColorVals(categories) {
	i = 0;
//	total = Object.keys(categories).length -1
	for(c in categories) {
	    categories[c].color = i / (categories.length -1);
	    i = i + 1;	    
	}
    }

    function assignDates() {
	allDates = []
	i = 0
	while (i<70) {
	    allDates.push(globals.units.minYear + i)
	    i = i + 1;
	}
	return allDates;
    }

    function setLang() {
    	domain = window.location.hostname;
	if(domain == 'interculturalconversations.com' || domain == 'localhost') {
	    globals.lang = 'en';
	} else if( domain == 'conversacionesinterculturales.com') {
	    globals.lang = 'es';
	}
	
/*	for(d in AppData.copy) {
	    AppData.copy[d] = AppData.copy[d][globals.lang];
	};
	globals.copy = AppData.copy;*/
    }
})();
